'use client';

import React from 'react';

export function BookingTermsText({ text }: { text: string }) {
  return (
    <div dir="auto" className="text-muted-foreground text-sm break-words whitespace-pre-wrap">
      {text}
    </div>
  );
}
